export enum PaymentType {
  CASH_ON_DELIVERY = 'CASH_ON_DELIVERY',
  BANK_TRANSFER = 'BANK_TRANSFER',
  DEFERRED_PAYMENT = 'DEFERRED_PAYMENT'
}
